var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uik-data-label",class:("uik-data-label--" + _vm.size)},[(_vm.color)?_c('div',{staticClass:"uik-data-label__color",class:[
            (("uik-data-label__color--" + _vm.color)),
            {'uik-data-label__color--fill': _vm.fill}
        ]}):_vm._e(),(_vm.text)?_c('div',{staticClass:"uik-data-label__text",attrs:{"title":_vm.text}},[_vm._v(_vm._s(_vm.text))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }